<template>
  <div
    class="navbar__drawer"
    :class="{ 'navbar__drawer--close': !hasMainMenuOpen }"
  >
    <v-btn
      class="navbar__drawer__toogle"
      icon
      @click="handleMainManuToogle"
    >
      <v-icon color="white">menu</v-icon>
    </v-btn>

    <EmployeeButton />
    <Menu />
    <WebcallButton v-if="false" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import EmployeeButton from 'components/Navbar/employeeButton'
import Menu from 'components/Navbar/menu'
import WebcallButton from 'components/Navbar/webcallButton'

export default {
  name: 'NavigationDrawer',
  components: {
    EmployeeButton,
    Menu,
    WebcallButton
  },
  computed: {
    ...mapState({
      hasMainMenuOpen: ({ mainMenu }) => mainMenu.isOpen
    })
  },
  methods: {
    ...mapActions({
      handleMainManuToogle: 'mainMenu/toggle'
    })
  }
}
</script>

<style lang="scss" scoped>
.navbar__drawer {
  background-color: darken($gray-7, 3);
  bottom: 0;
  left: -100%;
  padding: 125px 0 36px;
  position: fixed;
  top: 0;
  width: 100%;

  @media (min-width: 961px) {
    left: 0;
    width: $menu-width;
  }

  &.navbar__drawer--close {
    left: 0;

    @media (min-width: 961px) {
      width: $mini-menu-width;
    }
  }
}

.navbar__drawer__toogle {
  left: 10px;
  position: fixed;
  top: 10px;

  @media (min-width: 961px) {
    left: 16px;
    top: 38px;
  }
}
</style>
